const DEFAULT_DURATION_MS = 5000;

const VARIANT_CLASS = {
    info: 'alert-info',
    success: 'alert-success',
    warning: 'alert-warning',
    error: 'alert-danger',
};

let active_toast = null;
let dismiss_timer = null;

/**
 * Kore API flash messages use ht() (HTML-escaped). Toast uses textContent,
 * so decode entities before display (&apos; → ', &amp; → &, …).
 *
 * @param {string} value
 * @returns {string}
 */
export function decode_html_entities(value) {
    if (!value || typeof value !== 'string')
        return value || '';
    if (typeof document === 'undefined')
        return value;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
}

export function dismiss_app_toast() {
    if (dismiss_timer) {
        window.clearTimeout(dismiss_timer);
        dismiss_timer = null;
    }
    if (active_toast?.parentNode)
        active_toast.parentNode.removeChild(active_toast);
    active_toast = null;
}

/**
 * Ephemeral toast aligned with Kronos convention: Bootstrap alert, fixed bottom-right
 * (see #root .alert in index.scss). Do not use alert-inline here.
 *
 * @param {string} content
 * @param {{ variant?: 'info'|'success'|'warning'|'error', duration_ms?: number, link?: { href: string, label: string } }} [options]
 */
export function show_app_toast(content, { variant = 'info', duration_ms = DEFAULT_DURATION_MS, link } = {}) {
    if (!content)
        return;

    const root = document.getElementById('root');
    if (!root)
        return;

    dismiss_app_toast();

    const text = decode_html_entities(String(content));

    const el = document.createElement('div');
    el.className = `alert ${VARIANT_CLASS[variant] || VARIANT_CLASS.info} app-toast`;
    el.setAttribute('role', 'alert');

    if (link?.href && link?.label) {
        el.appendChild(document.createTextNode(`${text} `));
        const anchor = document.createElement('a');
        anchor.href = link.href;
        anchor.textContent = link.label;
        anchor.className = 'alert-link';
        el.appendChild(anchor);
    } else {
        el.textContent = text;
    }

    root.appendChild(el);
    active_toast = el;

    dismiss_timer = window.setTimeout(() => {
        dismiss_app_toast();
    }, duration_ms);
}
